import {
  MY_HOME_PATH,
  MY_HOME_ERROR_CODES_REDIRECTION,
} from "shared/constants";
import { i18n } from "i18n";
import { AlertConfigBuilder } from "shared/utils/alert-config-builder";
import GlobalAlertMessage from "./GlobalAlertMessage";

export interface IErrorPopupContent {
  title: string;
  description: string;
  actionButtonText: string;
  closeButtonText: string;
}

export const IErrorPopupContentKeys = [
  "title",
  "description",
  "actionButtonText",
  "closeButtonText",
];

export enum ErrorTypes {
  UnknownError = 0,
  GeneralError = 1,
  InternalServerError = 500,
  AccessDenyError = 403,
}

export interface IErrorNotificationData {
  errorType: ErrorTypes;
  error?: any;
  errorAction?: () => void;
}

const shouldRedirectToMyHomePage = (errorCode: number) =>
  MY_HOME_ERROR_CODES_REDIRECTION.includes(errorCode) &&
  window.location.pathname !== MY_HOME_PATH;

export class GlobalAlertContentFactory {
  public getErrorPopupSettings(
    errorContent: IErrorPopupContent,
    errorData: IErrorNotificationData
  ): GlobalAlertMessage {
    return this.getGlobalAlertMessage(errorContent, errorData);
  }

  private getGlobalAlertMessage(
    content: IErrorPopupContent,
    errorData: IErrorNotificationData
  ) {
    const { t } = i18n;

    return new AlertConfigBuilder()
      .initBuildEntity()
      .setDefaultContent({
        title: content.title,
        description: content.description,
        closeButtonText: content.closeButtonText,
        closePopupButtonText: content.closeButtonText,
      })
      .setCloseButton({
        name: shouldRedirectToMyHomePage(errorData.errorType)
          ? t("common:errorPopup.httpStatus.redirect")
          : content.actionButtonText,
        click: errorData.errorAction
          ? errorData.errorAction
          : () => this.errorAction(errorData.errorType),
      })
      .setPopupProps({
        close: () => this.popupPropsCloseAction(errorData.errorType),
      })
      .build();
  }

  private popupPropsCloseAction(errorCode: number) {
    if (shouldRedirectToMyHomePage(errorCode)) {
      window.location.replace(MY_HOME_PATH);
    }
  }

  private errorAction(errorCode: number) {
    if (shouldRedirectToMyHomePage(errorCode)) {
      window.location.replace(MY_HOME_PATH);
    } else {
      location.reload();
    }
  }
}
